import { Box, Typography } from '@mui/material';

import { useAppSelector } from 'store';
import { InviteData, selectInvite } from 'store/invite';

import ProfileImage from '../../../../assets/images/LoginLeftImage.png';
import styles from './ProfileLayout.module.scss';

export const ProfileLayout = () => {
  const invite: InviteData = useAppSelector(selectInvite)!;

  return (
    <Box className={styles.layoutContainer}>
      <img className={styles.registerImage} src={ProfileImage} />
      <Typography variant='h1' className={styles.createRoomText}>
        Create Waiting Room
      </Typography>
      <Box className={styles.layoutItem}>
        <Typography variant='body2' className={styles.createRoomDesc}>
          This will be your room for
          <Typography component='span' fontWeight='bold'>
            {invite.organizationName}
          </Typography>
          .
        </Typography>
      </Box>
      <Box className={styles.layoutItem}>
        <Typography variant='body2'>
          Your
          <Typography component='span' fontWeight='bold'>
            Room Name URL is required
          </Typography>
          and will be used to host all your sessions. You can customize your waiting room settings
          <Typography component='span' fontWeight='bold'>
            later at any time
          </Typography>
          . If you belong to more than one
          <Typography component='span' fontWeight='bold'>
            Organization
          </Typography>
          , you can switch between
          <Typography component='span' fontWeight='bold'>
            Organizations at any time using the same login
          </Typography>
          .
        </Typography>
      </Box>
    </Box>
  );
};
